var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCataloniaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 17h62v38h-62z",
    fill: "#f1b31c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d22f27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 22h62v4h-62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 30h62v4h-62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 38h62v4h-62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 46h62v4h-62z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5 17h62v38h-62z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCataloniaFlag);
export default __webpack_public_path__ + "static/media/catalonia-flag.75abef6180ec575bc3f685f7c45b7c1e.svg";
export { ForwardRef as ReactComponent };